import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../Wrapper/Wrapper';
import HorizontalSpacer from '../../HorizontalSpacer/HorizontalSpacer';

const displayReduction = (sale, reductionPercentage) => (
  <Wrapper data-cy="single-product-price-reduction" style={{ display: 'inline-block', color: 'rgb(255, 51, 51)' }}>
    {sale ? 'Sale' : ` ${reductionPercentage}% OFF`}
  </Wrapper>
);

const ReducedPrice = ({ formatterPriceAfterReduction, reductionPercentage, showSale = false }) =>
  reductionPercentage && reductionPercentage !== 0 ? (
    <Wrapper data-cy="single-product-price-reduced">
      <Wrapper
        data-cy="single-product-price-not-reduced"
        style={{ display: 'inline-block', color: '#999', textDecoration: 'line-through' }}
      >
        {formatterPriceAfterReduction}
      </Wrapper>
      <HorizontalSpacer style={{ display: 'inline-block' }} width="10px" />
      {displayReduction(showSale, reductionPercentage)}
    </Wrapper>
  ) : null;

ReducedPrice.propTypes = {
  formatterPriceAfterReduction: PropTypes.string,
  reductionPercentage: PropTypes.number,
  showSale: PropTypes.bool,
};

export default ReducedPrice;
